import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  collapse: {
    marginTop: '0.125rem',
    paddingBottom: '0.25rem',
  },
}));
